import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencyCountdown() {
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds
  const [dayName, setDayName] = useState('HOY');
  useEffect(() => {
    // Get Spanish day name
    const days = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
    setDayName(days[new Date().getDay()]);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          return 600; // Reset to 10 minutes
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <section className="py-6 px-4 bg-white" data-id="element-249">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3
    }} className="max-w-[480px] mx-auto p-5 border-2 border-black rounded-2xl bg-white shadow-md text-center" data-id="element-250">
        <h3 className="text-xl md:text-2xl font-black text-black uppercase leading-tight mb-3" data-id="element-251">
          OFERTA SOLO POR HOY
          <br data-id="element-252" />
          <span className="text-orange" data-id="element-253">{dayName}</span>
        </h3>

        <p className="text-sm text-black leading-snug mb-3 max-w-[340px] mx-auto" data-id="element-254">
          Tu lugar solo está reservado por{' '}
          <strong className="font-bold" data-id="element-255">10 minutos</strong>. Si no accedés tu
          descuento pasa a la siguiente persona.
        </p>

        <p className="text-sm text-black mb-4" data-id="element-256">La oferta se termina en:</p>

        <div className="flex justify-center gap-3" data-id="element-257">
          <div className="w-[92px] h-[78px] rounded-2xl bg-white border-2 border-orange flex flex-col items-center justify-center" data-id="element-258">
            <span className="text-4xl font-black text-black leading-none" data-id="element-259">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-[11px] font-medium text-black/60 uppercase tracking-wider mt-1" data-id="element-260">
              MINUTOS
            </span>
          </div>
          <div className="w-[92px] h-[78px] rounded-2xl bg-white border-2 border-orange flex flex-col items-center justify-center" data-id="element-261">
            <span className="text-4xl font-black text-black leading-none" data-id="element-262">
              {String(seconds).padStart(2, '0')}
            </span>
            <span className="text-[11px] font-medium text-black/60 uppercase tracking-wider mt-1" data-id="element-263">
              SEGUNDOS
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}